












































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import {
  PostNeirongZongti,
  PostNeirongTizhi,
  PostNeirongJumin
} from "@/request/hdr";
import TimeSelect from "./time-type-select.vue";
@Component({
  components: {
    TimeSelect
  }
})
export default class HdrAnalysisReportNeirong extends Vue {
  @Prop()
  private selectedHospitals: any;
  private pieColors: any = [
    "#759FFA",
    "#C1E7F5",
    "#85CFF1",
    "#F6CCC1",
    "#EC7E68",
    "#FCEAAE",
    "#F2C738",
    "#CDD0DD",
    "#7585A4",
    "#C8F1E1",
    "#76DEB6",
    "#C9DAFD"
  ];
  private message: any = {
    机构总体情况: {
      饼图: {}
    },
    中医体质情况: {},
    中医证型情况: {},
    居民心理类型情况: {
      table: {}
    }
  };
  private timeType: any = {
    机构总体情况: "全部时间",
    中医体质情况: "全部时间",
    中医证型情况: "全部时间",
    居民心理类型情况: "全部时间"
  };
  private customTime: any = {
    机构总体情况: [],
    中医体质情况: [],
    中医证型情况: [],
    居民心理类型情况: []
  };
  private zongtiPie: any = {
    color: this.pieColors,
    legend: {
      left: 5,
      orient: "vertical",
      data: [],
      icon: "circle"
    },
    grid: {
      width: "90%",
      right: "1%"
    },
    tooltip: {},
    series: [
      {
        type: "pie",
        data: [],
        radius: ["50%", "70%"],
        label: {
          show: false
        },
        center: ["70%", "50%"]
      }
    ]
  };
  private tizhiTypes: any[] = [
    "中医体质辨识",
    "四诊合参体质辨识",
    "儿童体质辨识",
    "老年人体质辨识",
    "备孕女性健康状态测评",
    "孕期女性健康状态测评",
    "产后女性健康状态测评",
    "围绝经期女性健康状态测评"
  ];
  private cTizhiType: any = "中医体质辨识";
  private tizhiBar: any = {
    color: ["#74A0FA"],
    xAxis: {
      type: "category"
    },
    yAxis: {},
    grid: {
      width: "90%",
      bottom: 40
    },
    tooltip: {},
    series: [
      {
        type: "bar",
        data: []
      }
    ]
  };
  private zhengxingTypes: any[] = ["高血压病辅助辨证", "糖尿病辅助辨证"];
  private cZhengxingType: any = "高血压病辅助辨证";
  private zhengxingBar: any = {
    color: ["#74A0FA"],
    xAxis: {
      type: "category"
    },
    yAxis: {},
    grid: {
      width: "90%",
      bottom: 40
    },
    tooltip: {},
    series: [
      {
        type: "bar",
        data: []
      }
    ]
  };
  private juminBar: any = {
    legend: {
      data: [],
      right: 0
    },
    color: ["#74A0FA", "#71DEB5"],
    xAxis: {
      type: "category"
    },
    yAxis: {},
    grid: {
      width: "90%",
      bottom: 40
    },
    tooltip: {},
    series: [
      {
        name: "高分人群",
        type: "bar",
        data: []
      },
      {
        name: "低分人群",
        type: "bar",
        data: []
      }
    ]
  };
  //   机构总体情况
  /**
   * @description 获得机构总体情况数据
   */
  private fetchZongti() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids
    };
    if (this.timeType["机构总体情况"] !== "自定义") {
      params["统计时间"] = this.timeType["机构总体情况"];
    } else {
      params["开始时间"] = this.customTime["机构总体情况"][0];
      params["结束时间"] = this.customTime["机构总体情况"][1];
    }
    PostNeirongZongti(this, params).then((data: any) => {
      this.message["机构总体情况"]["饼图"] = data;
      this.createZongtiPie();
    });
  }
  /**
   * @description 创建机构总体情况饼图
   */
  private createZongtiPie() {
    this.message["机构总体情况"]["饼图"]["data"].map((item: any) => {
      item.name = item.title;
    });
    this.zongtiPie.series[0].data = this.message["机构总体情况"]["饼图"][
      "data"
    ];
    this.zongtiPie.legend.data = this.message["机构总体情况"]["饼图"]["title"];
  }
  /**
   * @description 机构总体情况时间改变
   */
  private zongtiChange(type) {
    this.timeType["机构总体情况"] = type;
    this.fetchZongti();
  }
  /**
   * @description 机构总体情况时间自定义改变
   */
  private zongtiCustomTimeChange(val) {
    this.customTime["机构总体情况"] = val;
    this.fetchZongti();
  }
  // 中医体质情况
  private fetchTizhi() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      测评类型: this.cTizhiType
    };
    if (this.timeType["中医体质情况"] !== "自定义") {
      params["统计时间"] = this.timeType["中医体质情况"];
    } else {
      params["开始时间"] = this.customTime["中医体质情况"][0];
      params["结束时间"] = this.customTime["中医体质情况"][1];
    }
    PostNeirongTizhi(this, params).then((data: any) => {
      this.message["中医体质情况"] = data;
      this.createTizhiBar();
    });
  }
  /**
   * @description 创建体质柱状图
   */
  private createTizhiBar() {
    this.message["中医体质情况"]["data"].map((item: any) => {
      item.name = item.title;
    });
    this.tizhiBar.series[0].data = this.message["中医体质情况"]["data"];
    this.tizhiBar.xAxis.data = this.message["中医体质情况"]["title"];
  }
  /**
   * @description 体质类型变化
   */
  private tizhiTypeChange(type) {
    this.cTizhiType = type;
    this.fetchTizhi();
  }
  /**
   * @description 体质时间改变
   */
  private tizhiTimeChange(type) {
    this.timeType["中医体质情况"] = type;
    this.fetchTizhi();
  }
  /**
   * @description 体质时间自定义改变
   */
  private tizhiCustomTimeChange(val) {
    this.customTime["中医体质情况"] = val;
    this.fetchTizhi();
  }
  // 中医证型情况
  private fetchZhengxing() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      测评类型: this.cZhengxingType
    };
    if (this.timeType["中医证型情况"] !== "自定义") {
      params["统计时间"] = this.timeType["中医证型情况"];
    } else {
      params["开始时间"] = this.customTime["中医证型情况"][0];
      params["结束时间"] = this.customTime["中医证型情况"][1];
    }
    PostNeirongTizhi(this, params).then((data: any) => {
      this.message["中医证型情况"] = data;
      this.createZhengxingBar();
    });
  }
  /**
   * @description 创建证型柱状图
   */
  private createZhengxingBar() {
    this.message["中医证型情况"]["data"].map((item: any) => {
      item.name = item.title;
    });
    this.zhengxingBar.series[0].data = this.message["中医证型情况"]["data"];
    this.zhengxingBar.xAxis.data = this.message["中医证型情况"]["title"];
  }
  /**
   * @description 证型类型变化
   */
  private zhengxingTypeChange(type) {
    this.cZhengxingType = type;
    this.fetchZhengxing();
  }
  /**
   * @description 证型时间改变
   */
  private zhengxingTimeChange(type) {
    this.timeType["中医证型情况"] = type;
    this.fetchZhengxing();
  }
  /**
   * @description 证型时间自定义改变
   */
  private zhengxingCustomTimeChange(val) {
    this.customTime["中医证型情况"] = val;
    this.fetchZhengxing();
  }
  // 居民心理类型情况
  private fetchJumin() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids
    };
    if (this.timeType["居民心理类型情况"] !== "自定义") {
      params["统计时间"] = this.timeType["居民心理类型情况"];
    } else {
      params["开始时间"] = this.customTime["居民心理类型情况"][0];
      params["结束时间"] = this.customTime["居民心理类型情况"][1];
    }
    PostNeirongJumin(this, params).then((data: any) => {
      this.message["居民心理类型情况"] = data;
      this.createJuminBar();
    });
  }
  /**
   * @description 创建居民心理柱状图
   */
  private createJuminBar() {
    this.message["居民心理类型情况"]["居民心理类型情况"]["high"].map(
      (item: any) => {
        item.name = item.title;
      }
    );
    this.message["居民心理类型情况"]["居民心理类型情况"]["low"].map(
      (item: any) => {
        item.name = item.title;
      }
    );
    this.juminBar.series[0].data = this.message["居民心理类型情况"][
      "居民心理类型情况"
    ]["high"];
    this.juminBar.series[1].data = this.message["居民心理类型情况"][
      "居民心理类型情况"
    ]["low"];
    this.juminBar.xAxis.data = this.message["居民心理类型情况"][
      "居民心理类型情况"
    ]["title"];
    this.juminBar.legend.data = ["高分人群", "低分人群"];
  }
  /**
   * @description 居民时间改变
   */
  private juminTimeChange(type) {
    this.timeType["居民心理类型情况"] = type;
    this.fetchJumin();
  }
  /**
   * @description 居民时间自定义改变
   */
  private juminCustomTimeChange(val) {
    this.customTime["居民心理类型情况"] = val;
    this.fetchJumin();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$watch(
      () => {
        return this.selectedHospitals;
      },
      () => {
        this.fetchZongti();
        this.fetchTizhi();
        this.fetchZhengxing();
        this.fetchJumin();
      },
      {
        immediate: true
      }
    );
  }
}
